var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(
      (_vm._column.marks.is('IS_ADMIN') ||
      _vm.$session?.permissions.any('SHOP_REASSIGN', 'SHOW_ALL_MENUS')
      ) && _vm.show
    )?_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.chooseAdmin}},[_vm._v(_vm._s(_vm._column.users))]):_vm._e(),(
      !_vm._column.marks.is('IS_ADMIN') &&
      !_vm.$session?.permissions.any('SHOP_REASSIGN', 'SHOW_ALL_MENUS') && _vm.show
    )?_c('span',[_vm._v(" - ")]):_vm._e(),(!_vm.show)?_c('span',[_vm._v("-")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }